import { render } from "./FooterLinkList.vue?vue&type=template&id=5aecbb53&scoped=true"
import script from "./FooterLinkList.vue?vue&type=script&lang=js"
export * from "./FooterLinkList.vue?vue&type=script&lang=js"

import "./FooterLinkList.vue?vue&type=style&index=0&id=5aecbb53&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aecbb53"]])

export default __exports__